import React from "react";

import HomeLayout from "./HomeLayout";
import HomeFirstSection from "./HomeFirstSection";
import HomePayrollSection from "./HomePayrollSection";
import HomeInvoiceSection from "./HomeInvoiceSection";
import HomeComplianceSection from "./HomeComplianceSection";
import HomeInsuranceSection from "./HomeInsuranceSection";
import HomeContactSection from "./HomeContactSection";

export default function BackofficeLandingPage() {
  return (
    <HomeLayout>
      <HomeFirstSection />
      <HomePayrollSection />
      <HomeInvoiceSection />
      <HomeComplianceSection />
      <HomeInsuranceSection />
      <HomeContactSection />
    </HomeLayout>
  );
}
